import { EXTERNAL_FEATURE_PATHS } from '@commons/utils/featurePaths';

/**
 * The list holds its tab, its page and its sort in the query string, so returning to the bare path
 * would silently send the user back to the first page of the "Toutes" tab. The URL the list was left
 * on therefore travels to the form through the router state, and every way out of the form returns
 * to it.
 */
const RETURN_LOCATION_STATE_KEY = 'from';

/**
 * Router state carrying the list URL a form is opened from, query string included. It is read from
 * the browser and not from the router location prop, which was measured lagging behind: the list
 * rewrites its params through `replaceIn`, and the prop could still hold a page the list had already
 * normalized. Worth revisiting the day the router runs under a `basename`, since the two paths would
 * then differ.
 *
 * @returns {Object} The state to push along with the form path
 */
export const buildOrdersListReturnState = () => ({
  [RETURN_LOCATION_STATE_KEY]: `${window.location.pathname}${window.location.search}`,
});

/**
 * Where a form must return to: the list as it was left, or its bare path when the form was opened
 * from a pasted URL and carries no state.
 *
 * @param {Object} location - The router location of the form
 *
 * @returns {string} The path to push
 */
export const getOrdersListReturnLocation = (location) =>
  location?.state?.[RETURN_LOCATION_STATE_KEY] ?? EXTERNAL_FEATURE_PATHS.EXTERNAL_ORDERS;
